export const siteInfo = {
  name: "91.cn",
  tagline: "值得信赖的互联网服务平台",
  description: "91.cn 致力于为用户提供高效、安全、便捷的互联网服务。我们汇聚行业顶尖技术与服务资源，打造一站式的互联网解决方案，帮助个人和企业轻松应对数字化时代的各种挑战。",
  phone: "400-910-0091",
  email: "service@91.cn",
  address: "北京市海淀区中关村科技园区",
  icp: "京ICP备XXXXXXXX号",
  social: {
    wechat: "91_cn_official",
    weibo: "@91cn官方",
  },
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "服务分类", path: "/category/fuwu" },
  { label: "使用指南", path: "/category/zhinan" },
  { label: "关于我们", path: "/about" },
];

export const serviceFeatures = [
  {
    icon: "ri-shield-check-line",
    title: "安全可靠",
    description: "采用银行级加密技术，全方位保障您的数据安全与隐私，让您放心使用每一项服务。",
  },
  {
    icon: "ri-flashlight-line",
    title: "高效便捷",
    description: "极简操作流程，三步即可完成核心操作。智能推荐引擎，帮您快速找到所需服务。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "专业支持",
    description: "7×24 小时专业客服团队在线待命，平均响应时间不超过 30 秒，解决您的每一个疑问。",
  },
  {
    icon: "ri-stack-line",
    title: "功能全面",
    description: "涵盖数据管理、智能分析、协作办公等八大核心模块，满足个人与企业的全方位需求。",
  },
  {
    icon: "ri-rocket-2-line",
    title: "持续创新",
    description: "每月迭代更新，紧跟技术前沿。AI 智能驱动，让平台功能始终保持行业领先水平。",
  },
  {
    icon: "ri-group-line",
    title: "千万用户信赖",
    description: "服务超过 1000 万用户，覆盖全国 300 多个城市，用户满意度高达 98.6%。",
  },
];

export const stats = [
  { value: "1000万+", label: "服务用户" },
  { value: "300+", label: "覆盖城市" },
  { value: "98.6%", label: "用户满意度" },
  { value: "8年+", label: "行业深耕" },
];

export const faqs = [
  {
    question: "91.cn 提供哪些核心服务？",
    answer: "91.cn 提供包括数据存储与管理、智能分析决策、团队协作办公、API 接口对接、安全防护、内容分发等八大核心服务模块，覆盖个人用户和企业用户的多种使用场景。所有服务均支持在线开通，无需安装任何软件。",
  },
  {
    question: "如何注册 91.cn 账号？",
    answer: "注册 91.cn 账号非常简单：点击页面右上角的「注册」按钮，输入您的手机号码或邮箱地址，设置密码并完成验证码验证，即可在 30 秒内完成注册。注册后立即可享受基础服务的免费试用。",
  },
  {
    question: "91.cn 的服务收费模式是怎样的？",
    answer: "91.cn 采用灵活的分层定价策略：基础版免费，适合个人日常使用；专业版每月 29 元起，提供更强大的功能；企业版按需定制，享受专属客户经理一对一服务。所有套餐均可随时升级或降级。",
  },
  {
    question: "企业用户如何接入 91.cn 平台？",
    answer: "企业用户可通过以下步骤快速接入：1) 注册企业账号并完成企业认证；2) 联系商务团队获取定制方案；3) 通过 API 接口或 SDK 快速集成；4) 专属技术团队全程支持，确保 48 小时内完成对接。",
  },
  {
    question: "91.cn 的数据安全性如何保障？",
    answer: "91.cn 采用多层次安全防护体系：数据传输使用 HTTPS/SSL 加密，数据存储采用 AES-256 加密算法，并通过了 ISO 27001 信息安全管理体系认证。同时我们提供自动备份和异地容灾，确保您的数据万无一失。",
  },
];

export const testimonials = [
  {
    name: "张伟",
    title: "某科技公司 CTO",
    content: "91.cn 的 API 接口设计非常优秀，我们的团队仅用两天就完成了全部对接。平台稳定性和响应速度超出预期，强烈推荐给所有技术团队。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20business%20attire%20against%20clean%20white%20studio%20background%2C%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20corporate%20headshot%20photography%20style&width=100&height=100&seq=avatar-01&orientation=squarish",
  },
  {
    name: "李芳",
    title: "某电商企业运营总监",
    content: "自从使用 91.cn 的数据分析服务后，我们的运营效率提升了 40%。智能报表功能让我们能够快速洞察业务趋势，做出更准确的决策。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20elegant%20business%20blazer%20against%20minimal%20white%20studio%20background%2C%20confident%20warm%20smile%2C%20soft%20diffused%20lighting%2C%20corporate%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish",
  },
  {
    name: "王强",
    title: "自由职业者",
    content: "作为个人用户，91.cn 的基础版完全满足我的日常需求。文件存储、在线协作这些功能都是免费的，界面也很清爽好用。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20casual%20business%20style%20against%20clean%20light%20background%2C%20natural%20relaxed%20expression%2C%20soft%20studio%20lighting%2C%20modern%20headshot%20photography&width=100&height=100&seq=avatar-03&orientation=squarish",
  },
];

export const timeline = [
  { year: "2018", title: "91.cn 正式上线", description: "平台正式对外发布，推出首批三大核心服务模块。" },
  { year: "2019", title: "用户突破 100 万", description: "凭借稳定可靠的服务质量，注册用户数快速增长突破百万大关。" },
  { year: "2020", title: "企业服务上线", description: "推出企业级解决方案，服务覆盖金融、教育、医疗等多个行业。" },
  { year: "2021", title: "完成 A 轮融资", description: "获得知名投资机构认可，完成 A 轮融资，加速产品迭代与技术创新。" },
  { year: "2022", title: "AI 智能引擎发布", description: "推出 AI 驱动的智能分析与推荐引擎，平台进入智能化新时代。" },
  { year: "2023", title: "用户突破 1000 万", description: "服务用户突破千万，覆盖全国 300+ 城市，成为行业标杆平台。" },
];